import axios from "axios";
import { splitMixedTamilWord, getTanglishForMixedWord } from "./tamilPhonetics";

const TRANSLATE_API_URL = "https://translation.digitalmoitech.com/translate";
const translationCache = new Map();

const CITY_TAMIL_DICTIONARY = {
  "abiramam": "அபிராமம்",
  "acharapakkam": "அச்சரப்பாக்கம்",
  "adirampattinam": "அதிராம்பட்டினம்",
  "agastheeswaram": "அகஸ்தீஸ்வரம்",
  "alangayam": "ஆலங்காயம்",
  "alangudi": "ஆலங்குடி",
  "alangulam": "ஆலங்குளம்",
  "alandur": "ஆலந்தூர்",
  "alavakottai": "ஆலவக்கோட்டை",
  "amalapuram": "அமலாபுரம்",
  "ambasamudram": "அம்பாசமுத்திரம்",
  "ambattur": "அம்பத்தூர்",
  "ambur": "ஆம்பூர்",
  "ammapet": "அммаப்பேட்டை",
  "anaimalai": "ஆனைமலை",
  "anaikatti": "ஆனைகட்டி",
  "anakaputhur": "அனகாபுத்தூர்",
  "andipatti": "ஆண்டிபட்டி",
  "arani": "ஆரணி",
  "arcot": "ஆற்காடு",
  "ariyalur": "அரியலூர்",
  "arkonam": "அரக்கோணம்",
  "arni": "ஆரணி",
  "arulmigu palaniandavar": "அருள்மிகு பழனியாண்டவர்",
  "aruppukkottai": "அருப்புக்கோட்டை",
  "attur": "ஆத்தூர்",
  "avadi": "ஆவடி",
  "avanashi": "அவிநாசி",
  "ayakudi": "ஆயக்குடி",
  "batlagundu": "வத்தலகுண்டு",
  "bhavani": "பவானி",
  "bhuvanagiri": "புவனகிரி",
  "chengalpattu": "செங்கல்பட்டு",
  "chengam": "செங்கம்",
  "chennai": "சென்னை",
  "chidambaram": "சிதம்பரம்",
  "chinnamanur": "சின்னமனூர்",
  "chinnasekkadu": "சின்னசேக்காடு",
  "coimbatore": "கோயம்புத்தூர்",
  "coonoor": "குன்னூர்",
  "cuddalore": "கடலூர்",
  "denkanikottai": "தேன்கனிக்கோட்டை",
  "devakottai": "தேவகோட்டை",
  "dharapuram": "தாராபுரம்",
  "dharmapuri": "தருமபுரி",
  "dindigul": "திண்டுக்கல்",
  "edappadi": "இடப்பாடி",
  "erode": "ஈரோடு",
  "ettayapuram": "எட்டயபுரம்",
  "gandarvakottai": "கந்தர்வகோட்டை",
  "gingee": "செஞ்சி",
  "gobichettipalayam": "கோபிசெட்டிபாளையம்",
  "gudalur": "கூடலூர்",
  "gudiyatham": "குடியாத்தம்",
  "harur": "அரூர்",
  "hosur": "ஓசூர்",
  "ilayangudi": "இளையான்குடி",
  "injambakkam": "இஞ்சம்பாக்கம்",
  "jalakandapuram": "ஜலகண்டாபுரம்",
  "jayamkondam": "ஜெயங்கொண்டம்",
  "kallakurichi": "கள்ளக்குறிச்சி",
  "kalpakkam": "கல்பாக்கம்",
  "kancheepuram": "காஞ்சிபுரம்",
  "kangayam": "காங்கேயம்",
  "karaikal": "காரைக்கால்",
  "karaikudi": "காரைக்குடி",
  "karamadai": "காரமடை",
  "kariapatti": "கரியாப்பட்டி",
  "karur": "கரூர்",
  "kayalpattinam": "காயல்பட்டினம்",
  "kilvelur": "கீழ்வேளூர்",
  "kodaikanal": "கொடைக்கானல்",
  "kodumudi": "கொடுமுடி",
  "kolathur": "கொளத்தூர்",
  "komarapalayam": "குமாரபாளையம்",
  "kotagiri": "கோத்தகிரி",
  "kovilpatti": "கோவில்பட்டி",
  "krishnagiri": "கிருஷ்ணகிரி",
  "kulasekharapatnam": "குலசேகரபட்டினம்",
  "kumbakonam": "கும்பகோணம்",
  "kunnam": "குன்னம்",
  "kurinjipadi": "குறிஞ்சிப்பாடி",
  "lalgudi": "லால்குடி",
  "madurai": "மதுரை",
  "madurantakam": "மதுராந்தகம்",
  "manapparai": "மணப்பாறை",
  "mannargudi": "மன்னார்குடி",
  "maraimalai nagar": "மறைமலைநகர்",
  "marthandam": "மார்த்தாண்டம்",
  "mayiladuthurai": "மயிலாடுதுறை",
  "melur": "மேலூர்",
  "mettupalayam": "மேட்டுப்பாளையம்",
  "mettur": "மேட்டூர்",
  "mudukulathur": "முதுகுளத்தூர்",
  "musiri": "முசிறி",
  "nagapattinam": "நாகப்பட்டினம்",
  "nagercoil": "நாகர்கோவில்",
  "namakkal": "நாமக்கல்",
  "nandambakkam": "நந்தம்பாக்கம்",
  "nanguneri": "நாங்குநேரி",
  "natham": "நத்தம்",
  "neyveli": "நெய்வேலி",
  "nilakkottai": "நிலக்கோட்டை",
  "oddanchatram": "ஒட்டன்சத்திரம்",
  "ooty": "ஊட்டி",
  "padmanabhapuram": "பத்மநாபபுரம்",
  "palani": "பழனி",
  "palayamkottai": "பாளையங்கோட்டை",
  "palladam": "பல்லடம்",
  "papanasam": "பாபநாசம்",
  "paramakudi": "பரமக்குடி",
  "parangipettai": "பரங்கிப்பேட்டை",
  "pattukkottai": "பட்டுக்கோட்டை",
  "pennadam": "பெண்ணாடம்",
  "pennagaram": "பெண்ணாகரம்",
  "perambalur": "பெரம்பலூர்",
  "periyakulam": "பெரியகுளம்",
  "perundurai": "பெருந்துறை",
  "pollachi": "பொள்ளாச்சி",
  "polur": "போளூர்",
  "ponneri": "பொன்னேரி",
  "pudukkottai": "புதுக்கோட்டை",
  "puliyankudi": "புளியங்குடி",
  "rajapalayam": "ராஜபாளையம்",
  "ramanathapuram": "இராமநாதபுரம்",
  "ranipet": "ராணிப்பேட்டை",
  "rasipuram": "ராசிபுரம்",
  "salem": "சேலம்",
  "sankarankovil": "சங்கரன்கோவில்",
  "sankari": "சங்ககிரி",
  "sattur": "சாத்தூர்",
  "sendurai": "செந்துறை",
  "sholinghur": "சோளிங்கர்",
  "sivagangai": "சிவகங்கை",
  "sivagiri": "சிவகிரி",
  "sivakasi": "சிவகாசி",
  "sriperumbudur": "ஸ்ரீபெரும்புதூர்",
  "srirangam": "ஸ்ரீரங்கம்",
  "tambaram": "தாம்பரம்",
  "tenkasi": "தென்காசி",
  "thanjavur": "தஞ்சாவூர்",
  "theni": "தேனி",
  "thirumangalam": "திருமங்கலம்",
  "thiruthuraipoondi": "திருத்துறைப்பூண்டி",
  "thiruvananthapuram": "திருவனந்தபுரம்",
  "thiruvottiyur": "திருவொற்றியூர்",
  "thoothukudi": "தூத்துக்குடி",
  "tindivanam": "திண்டிவனம்",
  "tirukalukundram": "திருக்கழுக்குன்றம்",
  "tirukkoyilur": "திருக்கோவிலூர்",
  "tirunelveli": "திருநெல்வேலி",
  "tirupathur": "திருப்பத்தூர்",
  "tiruppur": "திருப்பூர்",
  "tiruchendur": "திருச்செந்தூர்",
  "tiruchengode": "திருச்செங்கோடு",
  "tiruchirappalli": "திருச்சிராப்பள்ளி",
  "tirumullaivoyal": "திருமுல்லைவாயில்",
  "tirupur": "திருப்பூர்",
  "tiruvallur": "திருவள்ளூர்",
  "tiruvannamalai": "திருவண்ணாமலை",
  "tiruvaru": "திருவாரூர்",
  "udumalpet": "உடுமலைப்பேட்டை",
  "ulundurpettai": "உளுந்தூர்ப்பேட்டை",
  "usilampatti": "உசிலம்பட்டி",
  "uthangarai": "உத்தங்கரை",
  "uttiramerur": "உத்திரமேரூர்",
  "valapady": "வாழப்பாடி",
  "vandavasi": "வந்தவாசி",
  "vaniyambadi": "வாணியம்பாடி",
  "vellore": "வேலூர்",
  "velur": "வேளூர்",
  "vikramasingapuram": "விக்கிரமசிங்கபுரம்",
  "virudhachalam": "விருத்தாசலம்",
  "virudhunagar": "விருதுநகர்",
  "walajabad": "வாலாஜாபாத்",
  "walajapet": "வாலாஜாப்பேட்டை",
  "yercaud": "ஏற்காடு"
};

/**
 * Transliterate English text to Tamil
 * Results are cached to avoid repeated API calls
 */
export const translateToTamil = async (text) => {
  if (!text) return null;

  const normalized = text.toLowerCase().trim();
  if (CITY_TAMIL_DICTIONARY[normalized]) {
    return CITY_TAMIL_DICTIONARY[normalized];
  }

  const cacheKey = `en-ta:${text}`;
  if (translationCache.has(cacheKey)) {
    return translationCache.get(cacheKey);
  }

  const mixed = splitMixedTamilWord(text.trim());
  if (mixed) {
    const { leadingNonTamil, tamilPrefix, englishSuffix } = mixed;
    const tanglishWord = getTanglishForMixedWord(tamilPrefix, englishSuffix);
    try {
      const res = await axios.post(
        TRANSLATE_API_URL,
        { text: tanglishWord, source: "en", target: "ta", mode: "transliterate" },
        { headers: { "Content-Type": "application/json" } }
      );
      const suggestions = Array.isArray(res.data?.suggestions) ? res.data.suggestions : [];
      const match = suggestions.find((s) => s.startsWith(tamilPrefix)) || res.data?.translated;
      if (match) {
        const result = (leadingNonTamil || "") + match;
        translationCache.set(cacheKey, result);
        return result;
      }
    } catch (e) {}
  }

  try {
    const res = await axios.post(
      TRANSLATE_API_URL,
      { text, source: "en", target: "ta", mode: "transliterate" },
      { headers: { "Content-Type": "application/json" } }
    );

    const translated =
      (Array.isArray(res.data.suggestions) && res.data.suggestions[0]) ||
      res.data.translated;

    if (translated && translated !== text) {
      translationCache.set(cacheKey, translated);
      return translated;
    }
  } catch (error) {
    console.error("Translation error:", error);
  }

  return null;
};

/**
 * Translate Tamil text to English (reverse transliteration)
 * This helps when user types in Tamil
 */
export const translateFromTamil = async (text) => {
  if (!text) return null;

  const cacheKey = `ta-en:${text}`;
  if (translationCache.has(cacheKey)) {
    return translationCache.get(cacheKey);
  }

  try {
    const res = await axios.post(
      TRANSLATE_API_URL,
      { text, source: "ta", target: "en", mode: "transliterate" },
      { headers: { "Content-Type": "application/json" } }
    );

    const translated =
      (Array.isArray(res.data.suggestions) && res.data.suggestions[0]) ||
      res.data.translated;

    if (translated) {
      translationCache.set(cacheKey, translated);
      return translated;
    }
  } catch (error) {
    console.error("Translation error:", error);
  }

  return null;
};

/**
 * Filter cities supporting both English and Tamil search
 * OPTIMIZED: Only translates cities that match English first, reduces API calls
 * @param {Array} cities - Array of city names in English
 * @param {string} query - Search query (can be English or Tamil)
 * @param {Map} tamilCache - Map to store Tamil translations
 * @returns {Promise<Array>} - Filtered cities up to limit
 */
export const filterCitiesWithTamilSupport = async (
  cities,
  query,
  tamilCache,
  limit = 25
) => {
  if (!query || query.trim().length === 0) {
    return cities.slice(0, limit);
  }

  let searchLower = query.toLowerCase().trim();
  const mixedQuery = splitMixedTamilWord(query.trim());
  if (mixedQuery) {
    const translatedQuery = await translateToTamil(query.trim());
    if (translatedQuery) {
      searchLower = translatedQuery.toLowerCase().trim();
    }
  }
  const isTamilInput = /[\u0B80-\u0BFF]/.test(searchLower); // Tamil Unicode range

  // Step 1: Collect all English matches first (no API calls)
  const englishMatches = [];
  const nonMatches = [];
  
  for (const city of cities) {
    if (city.toLowerCase().includes(searchLower)) {
      englishMatches.push(city);
    } else {
      nonMatches.push(city);
    }
  }

  // Step 2: Return English matches if we have enough
  if (englishMatches.length > 0) {
    return englishMatches.slice(0, limit);
  }

  // Step 3: If input is Tamil and no English matches, only transliterate the already-filtered cities
  if (isTamilInput) {
    const results = [];

    // First check English-matched cities (already sorted/filtered)
    for (const city of englishMatches) {
      if (results.length >= limit) break;
      
      let cityTamil = tamilCache.get(city);
      if (!cityTamil) {
        cityTamil = await translateToTamil(city);
        if (cityTamil) {
          tamilCache.set(city, cityTamil);
        }
      }

      if (cityTamil && cityTamil.toLowerCase().includes(searchLower)) {
        results.push(city);
      }
    }

    // If still need more results, expand to non-matching cities
    if (results.length < limit) {
      for (const city of nonMatches) {
        if (results.length >= limit) break;
        
        let cityTamil = tamilCache.get(city);
        if (!cityTamil) {
          cityTamil = await translateToTamil(city);
          if (cityTamil) {
            tamilCache.set(city, cityTamil);
          }
        }

        if (cityTamil && cityTamil.toLowerCase().includes(searchLower)) {
          results.push(city);
        }
      }
    }

    return results;
  }

  return [];
};

/**
 * Clear the translation cache (useful for testing)
 */
export const clearTranslationCache = () => {
  translationCache.clear();
};

/**
 * Get cached translation or fetch it
 */
export const getCachedOrFetchTamil = async (text, tamilCache) => {
  if (tamilCache.has(text)) {
    return tamilCache.get(text);
  }

  const tamil = await translateToTamil(text);
  if (tamil) {
    tamilCache.set(text, tamil);
  }
  return tamil;
};
